export type ErrorPageTranslations = {
    matches: (language: string) => boolean;
    title: string;
    description: string;
    reloadPage: string;
};
const errorPageTranslations: Record<string, ErrorPageTranslations> = {
    en: {
        matches: (language) => language.startsWith("en"),
        title: "An error occurred.",
        description: "Something went wrong while loading this webpage.",
        reloadPage: "Reload page",
    },
    de: {
        matches: (language) => language.startsWith("de"),
        title: "Ein Fehler ist aufgetreten.",
        description: "Es gab Probleme beim Laden dieser Webpage.",
        reloadPage: "Seite neu laden",
    },
    it: {
        matches: (language) => language.startsWith("it"),
        title: "Si è verificato un errore.",
        description: "Qualcosa è andato storto durante il caricamento di questa pagina web.",
        reloadPage: "Ricarica pagina",
    },
};

export function findTranslations(language: string): ErrorPageTranslations {
    const matchingTranslations = Object.values(errorPageTranslations).find((translations) => translations.matches(language));
    return matchingTranslations ?? errorPageTranslations["en"];
}
